import { createSelector } from 'reselect';
import { getLocationEventCapacityByTiming } from 'shared/helpers';

const getEventLocations = state => state.tcEvent.eventLocations;
const getRooms = state => state.tcEvent.rooms;
const getRoomsDTO = state => state.tcEvent.roomsDTO;

const mapRoomsByLocaion = (locations, rooms, capacityFlag) =>
  locations.map((loc) => {
    const location = { ...loc };

    if (capacityFlag) {
      location.roomCapacity = 0;
      location.capacityStandard = getLocationEventCapacityByTiming(location, 'standard');
      location.capacityExtended = getLocationEventCapacityByTiming(location, 'extended');
    }

    const foundRooms = rooms.filter(room => room.locationEvent.id === location.locationEvent.id);
    if (!foundRooms.length) {
      return location;
    }
    foundRooms.forEach(r => {
      r.location = {
        name : location.name,
        id: location.id,
        area: location.area
      };
      if (capacityFlag) {
        location.roomCapacity += r.capacity;
      }
    });
    location.rooms = foundRooms;
    return location;
  });

export const mapRoomsByLocation = createSelector(
  [getEventLocations, getRooms],
  (locations, rooms) => {
    const updatedLocations = mapRoomsByLocaion(locations, rooms, false);

    return updatedLocations;
  }
);

export const mapRoomsByLocationWithCapacity = createSelector(
  [getEventLocations, getRooms],
  (locations, rooms) => {
    const updatedLocations = mapRoomsByLocaion(locations, rooms, true);

    return updatedLocations;
  }
);

export const hasEventPaperCapacity = createSelector(
  [getEventLocations],
  (locations) =>
    locations.some(loc => loc.locationEvent.locationEventCapacities.some(locExam => !locExam.capacityType.onlineFlag && locExam.capacity))
);

export const hasEventOnlineCapacity = createSelector(
  [getEventLocations],
  (locations) =>
    locations.some(loc => loc.locationEvent.locationEventCapacities.some(locExam => locExam.capacityType.onlineFlag && locExam.capacity))
);

export const getManualTimerFlags = createSelector(
  [getRoomsDTO],
  (rooms)=> {
  let data = {};
  if (rooms && rooms.length) {
    rooms.forEach(room => {
      data[room.id] = room;
    });
  }

  return data;
});
